export const ActionTypes = {
    FETCH_LIST_UNPRIORITIZED_ACTIONS_REQUEST: "FETCH_LIST_UNPRIORITIZED_ACTIONS_REQUEST",
    FETCH_LIST_UNPRIORITIZED_ACTIONS_SUCCESS: "FETCH_LIST_UNPRIORITIZED_ACTIONS_SUCCESS",
    FETCH_LIST_UNPRIORITIZED_ACTIONS_FAILURE: "FETCH_LIST_UNPRIORITIZED_ACTIONS_FAILURE",
}